import { SupplierBrokerModel } from '../../../api/admin/admin.types';
import { Action } from 'redux';
import { Page } from '../../../api/api.types';

export const GET_SUPPLIER_BROKER_LIST = 'GET_SUPPLIER_BROKER_LIST';
export const GET_SUPPLIER_BROKER = 'GET_SUPPLIER_BROKER';
export const POST_SUPPLIER_BROKER = 'POST_SUPPLIER_BROKER';
export const PUT_SUPPLIER_BROKER = 'PUT_SUPPLIER_BROKER';
export const DELETE_SUPPLIER_BROKER = 'DELETE_SUPPLIER_BROKER';

export interface SupplierBrokerState {
  supplierBrokers: SupplierBrokerModel[] | [];
  selectedSupplierBroker: SupplierBrokerModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
}

export interface GetSupplierBrokerListAction extends Action {
  type: typeof GET_SUPPLIER_BROKER_LIST;
  payload: {
    page: Page<SupplierBrokerModel>;
  };
}

export interface GetSupplierBrokerAction extends Action {
  type: typeof GET_SUPPLIER_BROKER;
  payload: {
    selectedSupplierBroker: SupplierBrokerModel | null;
  };
}

export interface PostSupplierBrokerAction extends Action {
  type: typeof POST_SUPPLIER_BROKER;
  payload: {
    success: boolean;
    selectedSupplierBroker: SupplierBrokerModel | null;
  };
}

export interface PutSupplierBrokerAction extends Action {
  type: typeof PUT_SUPPLIER_BROKER;
  payload: {
    selectedSupplierBroker: SupplierBrokerModel;
  };
}

export interface DeleteSupplierBrokerAction extends Action {
  type: typeof DELETE_SUPPLIER_BROKER;
  payload: {
    success: boolean;
  };
}

export type SupplierBrokerActionTypes =
  GetSupplierBrokerListAction
  | GetSupplierBrokerAction
  | PostSupplierBrokerAction
  | DeleteSupplierBrokerAction
  | PutSupplierBrokerAction;